import { render, staticRenderFns } from "./updateReferralOrder.vue?vue&type=template&id=38ff2984&scoped=true&"
import script from "./updateReferralOrder.vue?vue&type=script&lang=js&"
export * from "./updateReferralOrder.vue?vue&type=script&lang=js&"
import style0 from "./updateReferralOrder.vue?vue&type=style&index=0&id=38ff2984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ff2984",
  null
  
)

export default component.exports